import React, {
  Component,
  Fragment,
  useContext,
  useState,
  useEffect
} from "react";
import { withRouter } from "react-router-dom";
import { ContextConsumer, GlobalContext } from '../PA';


import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  ActionButton,
  Collapse,
  Button,
  Card,
  Head,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification,
  Switch,
} from "xsolla-uikit";
import { Link } from "react-router-dom";
// import PAgameKeysWidg from "./PAgameKeysWidg";
import { IntlProvider } from "react-intl";
import PAgameKeysWizard from "./PAgameKeysWizard";
import StepTabs from "xsolla-uikit/lib/step-tabs";
import PAContentBlock from "../PAContentBlock";
import DatePickerExample from "../DatePicker";
import SelectExample from "../SelectExample";
import CardNew from "../PAcardNew";
import {CardFlatten} from "../PAgkDashboard3";

import { PAinfoCollapsible } from '../uikit2';

import { PAgcGKbuypre } from './PAgcGKbuypre';
import { PAphysical } from './PAphysical';
import { PAskuName } from '../PAskuName';


import { years, timezones } from "./PAgameKeys";
import { relative } from "path";

export function GameKeyWizard_temp ({ history, closeModal }) {
  const [state, setState] = useState({
    wizard: 1
  });

  const steps = [
    { label: "Basic info" },
    { label: "Platforms" },
    { label: "Package prices" },
    { label: "Package assets" }
    // {label: 'Test Results', disabled: true},
  ].map((step, index) => ({
    ...step
  }));

  const stepsP = [
    { label: "Basic info" },
    { label: "Package prices" },
  ].map((step, index) => ({
    ...step
  }));

  const handleURL = function(sku) {
    (sku && history) ? history.history.push(`/game_store/${sku}`) : history.history.push("/game_store");
  };

  const globalContext = useContext(GlobalContext);

  const [goodType, setGoodType] = useState('dig')

  return (

    <Fragment>


          {state.wizard === 5 && <div style={{position: 'relative'}}>

          <div
            style={{
              backgroundColor: "rgb(197, 208, 219, 0.1)",
              position: 'absolute',
              height: 260,
              zIndex: 1,
              top: 0,
              width: '100%',
              left: 0,
              right: 0,
            }}
          />
          </div>}




      {/* <Modal
         size="lg"
         isOpen={state.wizard}
         onClose={() => {
           setState({ wizard: false });
           handleURL();
         }}
      > */}







          {state.wizard !== 5 && <div style={{
            marginBottom: 64
          }}>
          <div
            style={{
              backgroundColor: "rgb(197, 208, 219, 0.1)",
              position: 'absolute',
              height: 200,
              zIndex: 1,
              top: 0,
              width: '100%',
              left: 0,
              right: 0,
            }}
          />
          <FormGroup indentation="xlg">
            <Head
              align="center"
              indentation="lg"
            >New product</Head>
          </FormGroup>
          <FormGroup indentation="xlg">
              {/* <div className="step_tabs_pane"> */}
                {goodType === 'dig' && <StepTabs current={state.wizard} steps={steps} />}
                {goodType === 'phys' && <StepTabs current={state.wizard} steps={stepsP} />}
              {/* </div> */}
          </FormGroup>
          </div>}

          {state.wizard === 1 && <GKkey1 handleGoodType={(nw)=> {
            setGoodType(nw)
          }}/>}

          {state.wizard === 2 && <GKkey2 />}

          {state.wizard === 3 && <GKkey3 />}

          {state.wizard === 4 && <GKkey4 />}

          {state.wizard === 5 && <GKkey5 handleURL={handleURL} />}



          {state.wizard !== 5 && <div style={{position: 'relative'}}>
            {state.wizard !== 1 && (
              <div style={{
                position: 'absolute',
                zIndex: 10000,
                height: '100%',
                width: 56,
                display: 'flex',
                alignItems: 'center',
              }}>
                <Button
                  appearance="secondary"
                  style={{
                    position: "absolute",
                    left: 0,
                    color: "#747e8a"
                  }}
                  appearance="flatten"
                  onClick={e => {
                    setState({wizard:--state.wizard})
                  }}
                >
                <Icon name="chevron-reverse" />
                </Button>
              </div>
          )}





          <FormFooter sticky={true}>
            <Button
              type="submit"
              onClick={() => {
                setState({wizard: ++state.wizard})
              }}
              // reversed={true}
              // icon="chevron"
            >

              {state.wizard === 1 && `Set up platforms`}

              {state.wizard === 2 && `Set up pricing`}

              {state.wizard === 3 && `Upload assets`}

              {state.wizard === 4 && `Finish`}


            </Button>
          </FormFooter>





        </div>}


          {state.wizard === 5 && <FormFooter sticky={true}>
            <Button
              type="submit"
              appearance="outline"
              onClick={() => {
                // setState({isOpen: false})
                handleURL()
              }}
            >
              Close
            </Button>
          </FormFooter>}




    </Fragment>
  )
}







const GKkey1 = ({
  handleGoodType = ()=>void(0)
}) => {
  const [state, setState] = useState({
    buyPre: "pre",
    buyPreWhen: "quarter"
  });

  return (
    <div>
      <PAContentBlock
        // title="General Settings"
        nopadding={true}
        border={false}
      >

        <PAskuName
          // data = {blankKey}
        />

      </PAContentBlock>

      <PAContentBlock
        // title="Type of purchase"
        // nopadding={true}
        border={false}
        nopadding={true}
      >

          <PAgcGKbuypre/>

        <FormGroup indentation="lg">
          <PAphysical handleChange={(typ)=>{handleGoodType(typ)}} />
        </FormGroup>

        <FormGroup indentation="lg"></FormGroup>

      </PAContentBlock>
    </div>
  )
}






const GKkey22 = () => {
  const [state, setState] = useState({
    buyPre: "pre",
    buyPreWhen: "quarter"
  });

  return (
    <div>

<PAContentBlock
          // nopadding={true}
          title="Desktop platforms"
          // border={false}
        >


<FormGroup appearance="lg">
  <Checkbox
    name='1'
    label='Steam'
    input={{
      value: 1,
      onChange: e => {
        void(0)
      }
    }}
  />
</FormGroup>
</PAContentBlock>
    </div>
)}






const GKkey2 = () => {
  const [state, setState] = useState({
    buyPre: "pre",
    buyPreWhen: "quarter"
  });

  return (
    <div>

        <PAContentBlock
          nopadding={true}
          // title="General Settings"
          border={false}
        >

          {/* <FormGroup label="DRM info">
            <Switch
              name="switch_1"
              label="Steam"
              tooltip=""
              input={{
                value: false,
                onChange: ()=>{void(0)}
              }}
            />
          </FormGroup> */}

          <div className="ui-form__section__content">
          <FormGroup indentation="sm">
            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
            <div className="xsui-form-group__entry">
            <div className="xsui-switch-container">
            <div className="xsui-switch xsui-switch--align-right">


            <Switch
              name="switch_1"
              label="Steam"
              tooltip=""
              input={{
                value: true,
                onChange: ()=>{void(0)}
              }}
            />


</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div style={{marginLeft: 98}}>
<div className="xsui-tag-selector">
<div className="xsui-tag-selector__item">
<div className="xsui-tag xsui-tag--appearance-primary xsui-tag--selected" data-value={1}>
<div className="xsui-tag__label">Windows</div>
<div className="xsui-tag__trigger">
<i className="xsui-icon xsui-icon-remove-circle" style={{fontSize: 20, color: 'inherit'}} />
</div>
</div>
</div>
<div className="xsui-tag-selector__item">
<div className="xsui-tag xsui-tag--appearance-primary" data-value={2}>
<div className="xsui-tag__label">Linux</div>
<div className="xsui-tag__trigger">
<i className="xsui-icon xsui-icon-remove-circle" style={{fontSize: 20, color: 'inherit'}} />
</div>
</div>
</div>
<div className="xsui-tag-selector__item">
<div className="xsui-tag xsui-tag--appearance-primary" data-value={6}>
<div className="xsui-tag__label">Mac</div>
<div className="xsui-tag__trigger">
<i className="xsui-icon xsui-icon-remove-circle" style={{fontSize: 20, color: 'inherit'}} />
</div>
</div>
</div>
</div>
<div>
  <input type="hidden" name="drm[0]"  />
</div>
</div>


</FormGroup>


<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[1].enabled" data-value="false">
<input name="drm[1].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">Playstation</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[2].enabled" data-value="false">
<input name="drm[2].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">XBox</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[3].enabled" data-value="false">
<input name="drm[3].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">Uplay</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[4].enabled" data-value="false">
<input name="drm[4].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">Origin</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[5].enabled" data-value="false">
<input name="drm[5].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">DRM Free<div className="xsui-tooltip xsui-tooltip--offset-left">
<div className data-tooltipped aria-describedby="tippy-tooltip-7" data-original-title="undefined" style={{display: 'inline'}}>
<div className="xsui-tooltip__button" />
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup indentation="sm">
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">


            <Switch
              name="switch_1"
              label="GOG"
              tooltip=""
              input={{
                value: true,
                onChange: ()=>{void(0)}
              }}
            />

</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div style={{marginLeft: 98}}>
<div className="xsui-tag-selector">
<div className="xsui-tag-selector__item">
<div className="xsui-tag xsui-tag--appearance-primary xsui-tag--selected" data-value={1}>
<div className="xsui-tag__label">Windows</div>
<div className="xsui-tag__trigger">
<i className="xsui-icon xsui-icon-remove-circle" style={{fontSize: 20, color: 'inherit'}} />
</div>
</div>
</div>
<div className="xsui-tag-selector__item">
<div className="xsui-tag xsui-tag--appearance-primary" data-value={2}>
<div className="xsui-tag__label">Linux</div>
<div className="xsui-tag__trigger">
<i className="xsui-icon xsui-icon-remove-circle" style={{fontSize: 20, color: 'inherit'}} />
</div>
</div>
</div>
<div className="xsui-tag-selector__item">
<div className="xsui-tag xsui-tag--appearance-primary" data-value={6}>
<div className="xsui-tag__label">Mac</div>
<div className="xsui-tag__trigger">
<i className="xsui-icon xsui-icon-remove-circle" style={{fontSize: 20, color: 'inherit'}} />
</div>
</div>
</div>
</div>
<div>
<input type="hidden" name="drm[6]"  />
</div>
</div>


</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[7].enabled" data-value="false">
<input name="drm[7].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">Epic Games Store</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[8].enabled" data-value="false">
<input name="drm[8].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">Nintendo Switch eShop</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup border="md" style={{borderBottomColor: '#eff6fd'}}>
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[9].enabled" data-value="false">
<input name="drm[9].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">Discord Game Store</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>

<FormGroup >
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="drm[10].enabled" data-value="false">
<input name="drm[10].enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right">
<div className="xsui-switch__label">Oculus</div>
</div>
</div>
</div>
</div>
</div>

</FormGroup>
</div>


        </PAContentBlock>

    </div>
  )
}








export const PAcgGameKeyLoginUrls = () => {
  const [state, setState] = useState({
    buyPre: "pre",
    buyPreWhen: "quarter"
  });

  return (


        <FormGroup indentation="lg"
          label="Allow on these domains"
          tooltip="For sequrity reasons the widget can be placed only on approved domains"
        >
          <FormGroup indentation="sm">
            <Input
              input={{
                name: "with-icon",
                value: "",
                onChange: () => {
                  void(0);
                }
              }}
              offset="right"
              placeholder="https://mydomain.com"
              icon="delete"
            />
          </FormGroup>

          <FormGroup indentation="sm">
            <div className="add-field-button add-field-button__container">
<span>Add domain</span>
<i className="xsui-icon xsui-icon-add-circle" style={{fontSize: 24, color: 'rgb(0, 118, 255)'}} />
</div>
          </FormGroup>

        </FormGroup>




  )
}







const GKkey3 = () => {
  const [state, setState] = useState({
    buyPre: "pre",
    buyPreWhen: "quarter"
  });

  return (


        <div>


        <PAContentBlock
          border={true}
        >
          <div className="ui-form__group ui-form__group--bordered ui-form__group--space-normal">
            <div className="ui-form__group__label">
              <label>Default currency</label>
              <div className="xsui-tooltip">
                <div className data-tooltipped aria-describedby="tippy-tooltip-8" data-original-title="undefined" style={{display: 'inline'}}>
                  <div className="xsui-tooltip__button" />
</div>
                </div>
            </div>
            <div className="ui-form__group__content">
              <div className="price-settings-form__default-currency-container" data-id="default-currency-selector">
                <div className="xsui-select">
                  <div className="xsui-dropdown">
                    <div style={{display: 'block'}}>
                      <div style={{position: 'relative', width: '100%', display: 'block'}}>
                        <button name="default_currency" value="USD" placeholder="Select" className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="default_currency" data-value="USD">USD</button>
                        <div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
                      </div>
                    </div>
                    <div/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="xsui-form-group xsui-form-group--secondary xsui-form-group--direction-column xsui-form-group--indentation-md">
            <div className="xsui-form-group__label">Steam</div>
            <div className="xsui-form-group__entry">
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md xsui-form-group--border xsui-form-group--border-md">
                <div className="xsui-form-group__label">Enter price in default currency and local currencies</div>
                <div className="xsui-form-group__entry">
                  <div className="ui-form__prices-selector">
                    <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                      <div className="xsui-form-group__entry">
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                          <div style={{width: 140, flexShrink: 0}}>
                            <div className="xsui-select">
                              <div className="xsui-dropdown">
                                <div style={{display: 'block'}}>
                                  <div style={{position: 'relative', width: '100%', display: 'block'}}>
                                    <button name="drm[0].prices_array[0].name" value="USD" placeholder="Select" disabled className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only xsui-input--dock-right" type="button" data-id="drm[0].prices_array[0].name" data-value="USD">USD</button>
                                    <div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div style={{width: '100%', marginLeft: '-1px'}}>
                            <div style={{display: 'block'}}>
                              <div style={{position: 'relative', width: '100%', display: 'block'}}>
                                <input min={0} step="any" name="drm[0].prices_array[0].value" placeholder="Price" className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--dock-left" type="number" data-id="drm[0].prices_array[0].value" data-value defaultValue />
                              </div>
                            </div>
                          </div>

                          <div style={{marginLeft: 8, flexShrink: 0}}>
                            <button data-id="price-selector.0.button" data-value="add" className="xsui-button xsui-button--appearance-square xsui-button--size-md" type="button">
<div className="xsui-button__wrapper">
<div className="xsui-button__content">
<i className="xsui-icon xsui-icon-plus" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
</button>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="xsui-form-group xsui-form-group--secondary xsui-form-group--direction-column xsui-form-group--indentation-md">
<div className="xsui-form-group__label">GOG</div>
<div className="xsui-form-group__entry">
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
<div className="xsui-form-group__label">Enter price in default currency and local currencies</div>

<div className="xsui-form-group__entry">
<div className="ui-form__prices-selector">
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
<div className="xsui-form-group__entry">
<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
<div style={{width: 140, flexShrink: 0}}>
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="drm[6].prices_array[0].name" value="USD" placeholder="Select" disabled className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only xsui-input--dock-right" type="button" data-id="drm[6].prices_array[0].name" data-value="USD">USD</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
</div>
</div>
</div>
</div>
                            <div style={{width: '100%', marginLeft: '-1px'}}>
                              <div style={{display: 'block'}}>
                              <div style={{position: 'relative', width: '100%', display: 'block'}}>
<input min={0} step="any" name="drm[6].prices_array[0].value" placeholder="Price" className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--dock-left" type="number" data-id="drm[6].prices_array[0].value" data-value defaultValue />
                            </div>
</div>
</div>
<div style={{marginLeft: 8, flexShrink: 0}}>
                              <button data-id="price-selector.0.button" data-value="add" className="xsui-button xsui-button--appearance-square xsui-button--size-md" type="button">
                              <div className="xsui-button__wrapper">
                                <div className="xsui-button__content">
                                  <i className="xsui-icon xsui-icon-plus" style={{fontSize: 24, color: 'inherit'}} />
                                </div>
                              </div>
                            </button>
                          </div>
                          </div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

        </PAContentBlock>


        <PAContentBlock
          nopadding={true}
          border={false}
        >
          <div>
          <div className="ui-form__input-group ui-form__input-group--spaced">
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="tips_enabled" data-value="false">
<input name="tips_enabled" className type="checkbox" defaultValue="false" />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
<div className="ui-form__input-description">
<div className="ui-form__input-description__title">
<span>Enable tipping</span>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-9" data-original-title="undefined" style={{display: 'inline'}}>
<div className="xsui-tooltip__button" />
</div>
</div>
</div>
<p>Default tips: US$1.00, US$3.00, US$5.00.</p>
</div>
</div>

          </div>
        </PAContentBlock>



        </div>



  )
}






const GKkey4 = () => {
  const [state, setState] = useState({
    buyPre: "pre",
    buyPreWhen: "quarter"
  });

  return (


        <PAContentBlock
          nopadding={true}
          // title="General Settings"
          border={false}
        >


<FormGroup border="lg">
          <Switch
            input={{
              value: true,
              onChange: ()=>{void(0)}
            }}
            label="Imported game key delivery"
            sublabel={
              <div>
                If game keys have been imported, they will be used instead of requesting keys on demand.
              </div>
            }
            tooltip="Tooltip"
          />
</FormGroup>



        <FormGroup border="lg">




          {/* <FormGroup>
            <p>
              Upload CSV or TXT file. Use line break as the separator.
            </p>
          </FormGroup> */}



          <FormGroup>
            <PAinfoCollapsible title="How to export Steam Keys?">
                    To find the Google Analytics ID:{" "}
                    <ol>
                      <li>Sign in to your Analytics account.</li>
                      <li>
                        Click <strong>Admin</strong>.
                      </li>
                      <li>
                        Select an account from the menu in the <strong>Account</strong>{" "}
                        column.
                      </li>
                      <li>
                        Select a property from the menu in the <strong>Property</strong>{" "}
                        column.
                      </li>
                      <li>
                        Under <strong>Property</strong>, click{" "}
                        <strong>Tracking Info</strong> &gt; <strong>Tracking Code</strong>
                        .
                      </li>
                    </ol>
                    Your Google Analytics ID is displayed at the top of the page.
            </PAinfoCollapsible>
          </FormGroup>






          <FormGroup indentation="xs">
            <div class="ui-form__keys-uploader__container">
              <div>
                <span className="ui-form__keys-uploader__container__platform-title">Steam</span>
                <span className="ui-form__keys-uploader__container__status">No keys</span>
              </div>
              <div className="ui-form__keys-uploader__container__actions">
                <button type="button" className="ui-form__keys-uploader__container__actions__link ui-form__keys-uploader__container__actions__import">
                <i className="xsui-icon xsui-icon-upload" style={{fontSize: 20, color: 'inherit'}} />
                <span className="ui-form__keys-uploader__container__actions__import__text">Upload</span>
                </button>
                </div>
            </div>
          </FormGroup>


          </FormGroup>



          <FormGroup border="lg">


          <FormGroup>
            <PAinfoCollapsible title="How to export GOG Keys?">
                    To find the Google Analytics ID:{" "}
                    <ol>
                      <li>Sign in to your Analytics account.</li>
                      <li>
                        Click <strong>Admin</strong>.
                      </li>
                      <li>
                        Select an account from the menu in the <strong>Account</strong>{" "}
                        column.
                      </li>
                      <li>
                        Select a property from the menu in the <strong>Property</strong>{" "}
                        column.
                      </li>
                      <li>
                        Under <strong>Property</strong>, click{" "}
                        <strong>Tracking Info</strong> &gt; <strong>Tracking Code</strong>
                        .
                      </li>
                    </ol>
                    Your Google Analytics ID is displayed at the top of the page.
            </PAinfoCollapsible>
          </FormGroup>


            <FormGroup indentation="xs">
              <div class="ui-form__keys-uploader__container">
                <div>
                  <span className="ui-form__keys-uploader__container__platform-title">GOG</span>
                  <span className="ui-form__keys-uploader__container__status">No keys</span>
                </div>
                <div className="ui-form__keys-uploader__container__actions">
                  <button type="button" className="ui-form__keys-uploader__container__actions__link ui-form__keys-uploader__container__actions__import">
                  <i className="xsui-icon xsui-icon-upload" style={{fontSize: 20, color: 'inherit'}} />
                  <span className="ui-form__keys-uploader__container__actions__import__text">Upload</span>
                  </button>
                </div>
              </div>
            </FormGroup>

          </FormGroup>

        </PAContentBlock>


  )
}





const GKkey5 = ({
  status = false,
  handleURL=()=>{void(0)}
}) => {
  const [state, setState] = useState({
    buyPre: "pre",
    buyPreWhen: "quarter"
  });

  const [stat, setStat] = useState(status);


  return (


        <div>

        <FormGroup>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%"
              }}
            >
              <div
                style={{ marginTop: 20 }}
                className="launcher-published-dlg__status-title-img-background"
              >
                <img
                  src="//cdn.xsolla.net/publisher-v4/checkmark-white.32731f.svg"
                  onClick={()=>{setStat(!stat)}}
                />
              </div>

              {stat === true && <Head>Game store Created!</Head>}

              {stat !== true && <Head>(DRAFT) Game store Created!</Head>}


            </div>
          </FormGroup>



          <FormGroup
            indentation="lg"
          >
          <PAContentBlock
            nopadding={true}
            border={false}
          >

            <FormGroup indentation="xlg">

                      <div style={{display: ' grid', placeContent: 'center center'}}>


                                    <div style={{width: 360, position: 'relative', zIndex: 100}}>
                                      <Link to="/game_keys/my_project">
                                      <CardNew
                                        display='card'
                                        size="sm"
                                        appearance="solid"
                                      >
                                        <div
                                        className="xsui-misha-table-row"
                                        style={{
                                          color: 'black',
                                          display: `block`,
                                          flexDirection: "column",
                                          alignItems:  `start`,
                                          justifyContent: "space-between",
                                          gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr',
                                          placeContent: 'center center',
                                        }}>

                                        <FormGroup indentation="xs">
                                        {stat === true && <StatusDot status="enabled">Ready</StatusDot>}
                                        {stat !== true && <StatusDot status="testing">Draft</StatusDot>}
                                        </FormGroup>
                                              <h3>
                                                {`{Package name}`}
                                              </h3>


                                          <FormGroup indentation="xs">

                                            {stat === true && <div>
                                              Steam keys: 2000<br/>
                                              GOG keys: 1500
                                            </div>}

                                            {stat !== true && <div>
                                              <div style={{display:'flex'}}>
                                                Steam keys:&nbsp;&nbsp;<Button appearance="flatten">Upload keys</Button>
                                              </div>
                                              <div style={{display:'flex'}}>
                                                GOG keys:&nbsp;&nbsp;<Button appearance="flatten">Upload keys</Button>
                                              </div>
                                            </div>}

                                          </FormGroup>

                                      {/*

                                        <FormGroup indentation="xs">
                                          <h4>
                                           $19.99
                                          </h4>
                                        </FormGroup> */}



                                      </div>
                                      </CardNew>
                                      </Link>
                                      </div>

                                      </div>


</FormGroup>

 {/* <GKkey3 /> */}






 {/* <PAcgGameKeyLoginUrls /> */}


            <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              // gridTemplateRows: '200px 200px',
              gridColumnGap: "16px",
              // gridRowGap: "20px",
              // width: "100%"
            }}
          >


            <div
              onClick={e => {
                handleURL("newwidget");
              }}
            >
              <CardFlatten icon="gamekey">
                <h4>Sell via Widget</h4>
                <p>
                  Set up an embeddable widget for this game key
                  package
                </p>
              </CardFlatten>
            </div>

            <div
              onClick={e => {
                handleURL("newsite");
              }}
            >
              <CardFlatten>
                <h4>Sell via Landing Page</h4>
                <p>
                  Create a landing page
                </p>
              </CardFlatten>
            </div>
            </div>
            </PAContentBlock>

            <PAContentBlock
            nopadding={true}
            border={false}
          >
          <FormGroup
              label="Sell via direct link"
          >
          <InputCopy
            name="basic-input"
            disabled={true}
            input={{
              value: 'secure.xsolla.com/paystation2/?access_data={access_dat',
              onChange: () => {
                void 0;
              }
            }}
          />

          </FormGroup>
        </PAContentBlock>


          </FormGroup>




        </div>



  )
}



